import React from "react";
import TranslatedPage from "../../containers/TranslatedPage";
import { Translate } from "react-redux-i18n";
import IconFromPath from "../../containers/TranslatedPage/IconFromPath";
import { Button } from "@blueprintjs/core";
import AnchorLink from "react-anchor-link-smooth-scroll";

import "./WhiteMondayHowItWorksSection.scss";
import NewGiftDecorator from "../../containers/NewGiftDecorator/NewGiftDecorator";
const WhiteMondayHowItWorksSection = () => {
  return (
    <section className="white-monday-how-it-works large-padding" id="how-it-works">
      <div className="main-container">
        <div className="content-wrapper">
          <h1 className="hero-heading how-it-works">
            <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_header.heading" />
          </h1>
          <div className="white-monday-feature-list">
            <div className="feature-item">
              <div className="icon-wrapper">
                <IconFromPath
                  iconSize="48"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_how_it_works_1.icon"
                  custom={true}
                />
                <span className="icon-label">
                  <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_1.heading" />
                </span>
              </div>
              <div className="feature-copy">
                <h2 className="bp3-heading">
                  <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_1.subheading" />
                </h2>
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_1.content" />
              </div>
            </div>

            <div className="feature-item">
              <div className="icon-wrapper">
                <IconFromPath
                  iconSize="48"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_how_it_works_2.icon"
                  custom={true}
                />
                <span className="icon-label">
                  <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_2.heading" />
                </span>
              </div>
              <div className="feature-copy">
                <h2 className="bp3-heading">
                  <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_2.subheading" />
                </h2>
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_2.content" />
              </div>
            </div>

            <div className="feature-item">
              <div className="icon-wrapper">
                <IconFromPath
                  iconSize="48"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_how_it_works_3.icon"
                  custom={true}
                />
                <span className="icon-label">
                  <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_3.heading" />
                </span>
              </div>
              <div className="feature-copy">
                <h2 className="bp3-heading">
                  <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_3.subheading" />
                </h2>
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_3.content" />
              </div>
            </div>

            <div className="feature-item">
              <div className="icon-wrapper">
                <IconFromPath
                  iconSize="48"
                  className="icon primary-color"
                  path="whitemonday.content_blocks.whitemonday_how_it_works_4.icon"
                  custom={true}
                />
                <span className="icon-label">
                  <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_4.heading" />
                </span>
              </div>
              <div className="feature-copy">
                <h2 className="bp3-heading">
                  <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_4.subheading" />
                </h2>
                <TranslatedPage path="whitemonday.content_blocks.whitemonday_how_it_works_4.content" />
              </div>
            </div>
          </div>
          <div className="cta-area">
            <NewGiftDecorator>
              <Button
              className="main-cta button"
              intent="primary">
                <Translate value="whitemonday.landing_whitemonday.create_gift" />                
              </Button>
            </NewGiftDecorator>
            <span className="unsure-copy">
              <Translate value="whitemonday.landing_whitemonday.not_sure" />              
              <AnchorLink href="#about-ihopa" className="secondary-cta">
                  <strong> <Translate value="whitemonday.landing_whitemonday.learn_more" /></strong>
              </AnchorLink>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhiteMondayHowItWorksSection;
